import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import {MySiteRestService} from '@nuskin/my-site-api'
import { ProductDataService } from "@nuskin/ns-product";

import template from './my-site-categories-products.html';

export class MySiteCategoriesProducts extends PolymerElement {
    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'my-site-categories-products';
    }

    static get properties() {
        return {
            productDetailPath: {
                type: String,
                value: ''
            },
            categoriesProducts: {
                type: Array,
                value: []
            },
            localProducts: {
                type: Array,
                value: []
            },
            _productSmallTranslations: {
                type: Object,
                value: {}
            },
            categoriesProductsTitle: {
                type: String,
                value: ''
            },
            categoriesProductsLinkText: {
                type: String,
                value: ''
            },
            categoriesProductsDescription: {
                type: String,
                value: ''
            },
            priceType: {
                type: String,
                value: ''
            },
            forMySitePreview: {
                type: Boolean
            },
            properties: {
                type: Object,
                value: {
                    'tdc_backToHomeLabel': 'Back'
                }
            }
        }
    }

    async ready() {
        super.ready();
        this.set('basePath', window.location.pathname);
        let storefront = JSON.parse(sessionStorage.getItem("storefront"))
        const runConfig = JSON.parse(sessionStorage.getItem("run-config"))
        const country = runConfig ? runConfig.country : 'US'
        const language = runConfig ? runConfig.language : 'en'
        const url = new URL(location.href)
        const categoryId = Number(url.searchParams.get('categoryId'));  
        try {      
            if(!storefront) {
                const sponsorId =  await MySiteRestService.getCurrentSponsorId();    
                storefront = await MySiteRestService.getSponsorData(sponsorId,false);
            }
        } catch (error) {
            console.log("Exception happened in Mysite GetSponsor Call", error);
        }
        if (storefront) {
            for (const user in storefront.storefront) {
                const userStorefront = storefront.storefront[user]
                const userBundles = userStorefront[country].bundles
                const result = userBundles.filter(obj => obj.id === categoryId)[0];
                let skus = result.skus
                this.set('categoriesProducts', skus)

                //get bundles Info
                const bundlesInfo = userStorefront[country].lang[language].bundlesInfo
                if(bundlesInfo && bundlesInfo.length) {
                    let info = bundlesInfo.find(item => {
                        return item ? item.bundle_id === categoryId : {}
                    });
                    const title = info ? info.name : '';
                    const about = info ? info.about : ''
                    this.set('title', title)
                    this.set('description', about)
                }
                try {
                    if (!skus || !Array.isArray(skus)) return;
                    skus = skus.filter((sku) => sku !== undefined);
                    if (skus && skus.length > 0) {
                        // const data = await ProductDataService.getProductData(skus);
                        // if (data && data.products) {
                        //     this.localProducts = data.products.map((product) => {
                        //         return {
                        //             ...product,
                        //             sku: product.sku
                        //         };
                        //     });
                        // }

                        const batchSize = 6;
                        const results = [];
          
                        for (let i = 0; i < skus.length; i += batchSize) {
                            const batch = skus.slice(i, i + batchSize);
                            try {
                                const data = await ProductDataService.getProductData(batch);
                                if (data && data.products) {
                                    results.push(...data.products);
                                }
                            } catch (err) {
                                console.log("Failed to load batch,", err);
                            }
                        }
          
                        this.localProducts = results.map((product) => {
                            return {
                                ...product,
                                SKU: product.sku
                            };
                        });
                    }
                } catch (e) {
                    console.log("Failed to load products,", e);
                }
                  
            }
        } else {
            console.log("No storefront in storage")
        }
    }

    async connectedCallback() {
        this.subdomain = await MySiteRestService.getCurrentSubdomain()
    }


}

window.customElements.define(MySiteCategoriesProducts.is, MySiteCategoriesProducts);